import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/viewing-positions.md?raw';

const TradingViewingPositions: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingViewingPositions;
